/**
 * Admin card field configurations for mobile responsive views
 * Used across admin components for consistent card rendering
 */

// Admin Logs card fields configuration
export const ADMIN_LOGS_FIELDS = [
  { key: "action", label: "Action", getValue: (log) => log.action_type },
  { key: "decision", label: "Decision", getValue: (log) => log.decision },
  {
    key: "actor",
    label: "Actor",
    getValue: (log) => log.actor_name || log.actor,
  },
  {
    key: "target",
    label: "Target",
    getValue: (log) => log.target_user_name || log.target_user,
  },
  { key: "comment", label: "Comment", getValue: (log) => log.comment },
  { key: "date", label: "Date", getValue: (log) => formatDate(log.created_at) },
];

// Validate License card fields configuration
export const VALIDATE_LICENSE_FIELDS = [
  {
    key: "firstname",
    label: "Firstname",
    getValue: (item) => item.provider?.first_name || "",
  },
  {
    key: "lastname",
    label: "Lastname",
    getValue: (item) => item.provider?.last_name || "",
  },
  {
    key: "email",
    label: "Email",
    getValue: (item) => item.provider?.email || "",
  },
  {
    key: "phone",
    label: "Phone",
    getValue: (item) => item.provider?.phone || "",
  },
  { key: "license", label: "License", getValue: (item) => item.license || "" },
];

// Registered CPAs card fields configuration
export const REGISTERED_CPAS_FIELDS = [
  {
    key: "date_joined",
    label: "Date Joined",
    getValue: (cpa) => formatDate(cpa.date_joined),
  },
  {
    key: "first_name",
    label: "First Name",
    getValue: (cpa) => cpa.first_name || "",
  },
  {
    key: "last_name",
    label: "Last Name",
    getValue: (cpa) => cpa.last_name || "",
  },
  {
    key: "email",
    label: "Email",
    getValue: (cpa) => cpa.email || "",
  },
  {
    key: "account_status_display",
    label: "Status",
    getValue: (cpa) => cpa.account_status_display || "",
  },
  {
    key: "last_reminder_sent",
    label: "Last Reminder",
    getValue: (cpa) =>
      cpa.last_reminder_sent ? formatDate(cpa.last_reminder_sent) : "Never",
  },
];

/**
 * Get formatted address string for license validation cards
 * @param {Object} address - Address object
 * @returns {string} Formatted address string
 */
export const getFormattedAddress = (address) => {
  if (!address) return "-";

  const a = address;
  return a.address_line_one
    ? `${a.address_line_one}${
        a.address_line_two ? ", " + a.address_line_two : ""
      }${a.address_apt ? ", Apt " + a.address_apt : ""}, ${a.address_city}, ${
        a.address_state
      } ${a.address_zip}`
    : "-";
};

/**
 * Format date string to readable format
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  if (!dateString) return "-";

  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (error) {
    return dateString; // fallback to original string
  }
};
